import { render, staticRenderFns } from "./matching-sites.vue?vue&type=template&id=dedb1b02&scoped=true"
import script from "./matching-sites.vue?vue&type=script&lang=js"
export * from "./matching-sites.vue?vue&type=script&lang=js"
import style0 from "./matching-sites.vue?vue&type=style&index=0&id=dedb1b02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dedb1b02",
  null
  
)

export default component.exports